import React from "react";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import { Helmet } from "react-helmet";
import homeownershipImage from "../../assets/images/cta/4.webp";
import homeRepairImage from "../../assets/images/cta/12.webp";
import Card from "../../components/Card";
import CardSection from "../../components/CardSection";

const HowToApply = () => {
  const currentYear = new Date().getFullYear();
  const yearsActive = currentYear - 1985;
  const cards = [
    {
      title: "Homeownership",
      description:
        "Habitat Buffalo's core homeownership program provides safe, decent, affordable housing to hardworking families in need.",
      link: "/how-to-apply/homeownership",
      image: homeownershipImage,
    },
   
  ];

  return (
    <>
      <Helmet>
        <title>How to Apply - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Learn how to apply for Habitat for Humanity Buffalo's homeownership and home repair programs. Explore our eligibility criteria and start your application today."
        />
      </Helmet>
      <Container>
        <Overview>
          <OverviewText>
            For {yearsActive} years, Habitat for Humanity Buffalo has built
            homes and fulfilled dreams in partnership with hardworking
            individuals and families. Through a collaborative effort, Habitat
            Buffalo works towards increasing the affordable housing stock in our
            community. Check out these programs to see if you might be eligible
            to partner with us.
          </OverviewText>
        </Overview>
        <CardSection>
          {cards.map((card, index) => (
            <LazyLoad key={index} height={200} offset={100}>
              <Card
                title={card.title}
                description={card.description}
                link={card.link}
                image={card.image}
                alt={`Image for ${card.title}`} // Added alt text for accessibility
              />
            </LazyLoad>
          ))}
        </CardSection>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Overview = styled.div`
  padding: 50px 20px;
  text-align: center;
`;

const OverviewText = styled.p`
  font-size: 1.2em;
  max-width: 800px;
  margin: 0 auto;
`;

export default HowToApply;
